export default {
  name: "CustomAccountQuickSearchElement",
  emits: ["search", "handleSearchBarFocused", "handleSearchBarBlured"],
  props: {
    placeholder: {
      type: String,
      default: "",
      required: false
    },
    value: {
      type: String,
      default: "",
      required: false
    }
  },
  methods: {
    onInput(event) {
      if (event.target.value != "") {
        this.$emit('handleSearchBarFocused');
      } else {
        this.$emit('handleSearchBarBlured');
      }
      if (this.disabled || !event.target.checkValidity()) return;
      const value = event.target.value.split(",").filter(v => !!v).map(element => element.trim());
      this.$emit("search", {
        value
      });
    }
  }
};